import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import { connect } from "react-redux";
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem",
      width: "100%",
    },
    table: {
      maxWidth: "100%",
      margin: "auto",
    },
  })
);

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

interface Props {
  rateListExport: any;
  loading: boolean;
}

const BookingExport: React.FC<Props> = ({ rateListExport, loading }) => {
  const classes = useStyles();

  const columns: GridColDef[] = [
    { field: "id", headerName: "Code", width: 200 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "offer_price", headerName: "MRP", width: 200 },
    { field: "specialPrice", headerName: "SpecialPrice", width: 200 },
    { field: "specialMrp", headerName: "SpecialMrp", width: 200 },
  ];

  let rows = [];

  if (rateListExport && rateListExport.length > 0) {
    rows =
      rateListExport &&
      rateListExport.length > 0 &&
      rateListExport.map((rate: any) => {
        return {
          ...rate,
          id: rate?.package.code !== null ? rate?.package.code : "Na",
          name: rate?.package.name.replaceAll("\n", ""),
          offer_price: rate?.package.offer_price,
        };
      });
  }
  // console.log(rateListExport,"=======>")

  return (
    <main className={classes.content} style={{ width: "100%" }}>
      <div className={classes.toolbar} />
      <Paper elevation={15} className={classes.paper} style={{ width: "100%" }}>
        <div style={{ height: 700, width: "100%" }}>
          <DataGrid
            rowsPerPageOptions={[]}
            rows={rows}
            columns={columns}
            components={{
              Toolbar: CustomToolbar,
            }}
            pageSize={50}
            loading={loading}
          />
        </div>
      </Paper>
    </main>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {})(BookingExport);
